import request from '@/utils/request'
//get
export function getSuitAuthParam(param) {
    return request({
        url: `/suit_auth/${param}`,
        method: 'GET'
    })
}
export function getSuit() {
    return request({
        url: `/suit/`,
        method: 'GET'
    })
}

export function trail(data) {
    return request({
        url: `/suit_auth/trail/`,
        method: 'POST',
        data
    })
}
//试用延期
export function trialDelay(id){
    return request({
      url: `/suit_auth/${id}/delay`,
      method:'GET',
    })
}

export function buyPrice(data) {
    return request({
        url: `/suit_auth/buy_price/`,
        method: 'POST',
        data
    })
}

export function buy(data) {
    return request({
        url: `/suit_auth/buy/`,
        method: 'POST',
        data
    })
}

export function getCertificateById(id){
    return request({
      url: `/suit_auth/${id}/certificate/`,
      method:'GET',
    })
  }



// WEBPACK FOOTER //
// ./src/api/suit.js